module.exports = __webpack_public_path__ + "media/rise3.4fd73e58.mp4";